import React from "react";
import { PrivateLayout, PublicLayout } from "../layouts";
import { Redirect } from "react-router-dom";
// import AuthModule from '../components/Auth/AuthModule';
import Login from "../components/Auth/Login";
import SignUp from "../components/Auth/SignUp";
import ForgotPassword from "../components/Auth/ForgotPassword";
import ResetPassword from "../components/Auth/ResetPassword";
import SignUpOrganization from "../components/Auth/SignUpOrganization";
import SubadminLogin from "../components/Auth/SubadminLogin";
import PublicNewLayout from "../layouts/publicnew";
import AccountSetup from "../components/Auth/AccountSetup";
import DashboardliveStats from "../containers/DashboardLiveStats"
import { ipAddress } from "../utils/constants";
import { apiUrl, PORT } from "../environment";



const DashboardLiveStatsComponent = () => {
    const [userIP, setUserIP] = React.useState(null);
    const [allowedIps, setAllowedIps] = React.useState([]);
    const [loading, setLoading] = React.useState(true); // Add loading state

    React.useEffect(() => {
      const fetchIP = async () => {
          try {
              // Fetch the user's IP address
              const response = await fetch("https://api.ipify.org?format=json");
              if (!response.ok) {
                  throw new Error('Failed to fetch IP');
              }
              const data = await response.json();
              setUserIP(data.ip);
  
              // Fetch the allowed IP addresses
              const result = await fetch(`${apiUrl}${PORT}/dashboardStats/getAllowedIpAddresses`);
              if (!result.ok) {
                  throw new Error('Failed to fetch allowed IPs');
              }
              const allowedIps = await result.json();
              setAllowedIps(allowedIps);
          } catch (error) {
              console.error("Error fetching data:", error);
          } finally {
              setLoading(false); // Set loading to false after fetch completes
          }
      };
  
      fetchIP();
  }, []);

  // If still loading, show a loading message or spinner
  if (loading) {
    return <div>Loading...</div>;
  }


  console.log('allowedIps',allowedIps)

  // Once both userIP and allowedIps are fetched, check if userIP is allowed
  if (!allowedIps.includes(userIP)) {
    return <Redirect to="/login" />;
  }

  return <DashboardliveStats />;

    // if (userIP !== ipAddress.myIP 
    //   && userIP !== ipAddress.smartDataIP 
    //   && userIP !== ipAddress.clientIP 
    //   && userIP !== ipAddress.clientIP2
    //   && userIP !== ipAddress.clientIP3
    //   && userIP !== ipAddress.clientIP4
    //   && userIP !== ipAddress.clientIP5
    //   && userIP !== ipAddress.clientIP6
    //   && userIP !== ipAddress.clientIP7
    //   && userIP !== ipAddress.clientIP8
    //   && userIP !== ipAddress.clientIP9
    //   && userIP !== ipAddress.clientIP10
    //   && userIP !== ipAddress.clientIP11
    // ) {
    //    return <Redirect to="/login" />;
    //   }
    //   return <DashboardliveStats />;
};

const AuthRoutes =
  [
    {
      path: "/",
      exact: true,
      layout: PublicLayout,
      component: () => <Redirect to="/login" />
    },
    {
      path: "/login",
      layout: PublicLayout,
      component: Login
    },
    {
      path: "/dashboardliveStats",
      layout: DashboardLiveStatsComponent,
      component: DashboardLiveStatsComponent
    },
    {
			path: "/subadminLogin",
			layout: PublicNewLayout,
			component: SubadminLogin
		},
    {
      path: "/forgot-password",
      layout: PublicLayout,
      component: ForgotPassword
    },
    {
      path: "/account-setup/:passwordtoken",
      layout: PublicLayout,
      component: AccountSetup
    },
    {
      path: "/register",
      layout: PublicLayout,
      component: SignUp
    },
    {
      path: "/otp",
      layout: PrivateLayout
    },
    {
      path: "/reset-password/:passwordtoken",
      layout: PublicLayout,
      component: ResetPassword
    },
    {
      path: "/signup-organization",
      layout: SignUpOrganization,
      component: SignUpOrganization

      
    }
  ];


export default AuthRoutes;